<template>
    <section class="dispatchOrder-table" v-loading="loading">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="handleRefresh"
            >
                刷新
            </el-button>
        </div>
        <table-box
            ref="tablePage"
            :columns="config.table.columns"
            :height="config.table.height"
            :loading="loading"
            :rows="tableData"
            :actions="config.table.action"
            @action-click="actionClick"
        >
        </table-box>
        <m-page
            :current-page="currentPage"
            :pageData="config.page"
            :total="pageTotal"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"
            class="page-container"
        ></m-page>
        <!-- 取消到车登记附件页面 -->
        <dispatch-attachment
            v-if="showDispatchAttachment"
            @components-close="closeDispatchAttachment"
            :title="'取消到车登记附件页面'"
            :arrivalInfo="arrivalInfo"
            :dictData="dictData"
            :dispatchNo="dispatchNo"
        ></dispatch-attachment>
        <!-- 取消到车登记附件页面 -->
    </section>
</template>
<script>
import { confirmWithBtnLoading } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/components/util/index';
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import DispatchAttachment from '../../components/dispatchAttachment/Index';
import {
    quereyArrivalRegistration, cancelarrive
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import config from './config.js';
export default {
    name: 'dispatchArrivalRegistrationTabel',
    components: { tableBox, mPage, DispatchAttachment },
    props: {
        dispatchNo: {
            type: String,
            default () {
                return '';
            }
        },
        id: {
            type: Number,
            default () {
                return null;
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            currentPage: 1,
            arrivalInfo: '', // 取消到车信息
            showDispatchCancelArrivalCheckIn: false, // 是否显示取消到车确认页面
            showDispatchAttachment: false // 是否显示附件管理页面

        };
    },
    methods: {
        /**
        * @description 操作列事件处理
        * @event {事件类型} cancelArrival 取消到车登记确认页面、attachment 附件管理页面
        * @row   {Object} 行数据
       */
        actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'cancelArrival':
                    this.getCancelarrive(row);
                    break;
                case 'attachment':
                    this.showDispatchAttachment = true;
                    this.arrivalInfo = row;
                    break;
                default:
                    break;
            }
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
         * @getList 使用发车单号查询列表明细
         * @param {Object} searchParams 查询条件
         * @dispatchNo 发车单号：
         */
        async getList () {
            const searchParams = {
                ...this.page,
                param: {
                    dispatchNo: this.dispatchNo
                }
            };
            this.loading = true;
            quereyArrivalRegistration(searchParams).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(element => {
                        element.inOutTypeName = this.dictData.OTP_IN_OUT_TYPE[element.inOutType];
                        element.siteTypeName = this.dictData.SITE_TYPE[element.siteType];
                        element.statusName = this.dictData.ARRIVE_STATUS[element.status];
                    });
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.getList();
        },
        /**
         * @description 取消到车
         * @param row 表格所选参数
        */
        getCancelarrive (row) {
            const msg = '确定取消到车吗?';
            const params = {
                baseDispatchId: this.id,
                status: row.status,
                siteAddress: row.siteAddress,
                whCode: row.whCode,
                arrivalRegistrationTime: row.arrivalRegistrationTime,
                id: row.id
            };
            const errMsg = '操作成功';
            confirmWithBtnLoading(msg, params, cancelarrive, errMsg).then((res) => {
                this.getList();
                this.$message.success(res.msg || '操作成功');
            }).catch(() => { });
        },
        // 关闭到车确认页面
        closeDispatchCancelArrivalCheckIn () {
            this.showDispatchCancelArrivalCheckIn = false;
        },
        // 关闭附件页面
        closeDispatchAttachment () {
            this.showDispatchAttachment = false;
        }

    },
    mounted () {
        this.getList();
    }

};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
</style>
